// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApitypesCloudProvider } from './ApitypesCloudProvider';
import {
  ApitypesCloudProviderFromJSON,
  ApitypesCloudProviderFromJSONTyped,
  ApitypesCloudProviderToJSON,
  ApitypesCloudProviderToJSONTyped,
} from './ApitypesCloudProvider';

/**
 * DateIncurred date incurred
 * @export
 * @interface ApitypesUpsertEnvironmentCostRequest
 */
export interface ApitypesUpsertEnvironmentCostRequest {
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentCostRequest
   */
  cloudHostID?: string;
  /**
   *
   * @type {ApitypesCloudProvider}
   * @memberof ApitypesUpsertEnvironmentCostRequest
   */
  cloudProvider?: ApitypesCloudProvider;
  /**
   *
   * @type {number}
   * @memberof ApitypesUpsertEnvironmentCostRequest
   */
  cost?: number;
  /**
   * Format: 2026-12-31
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentCostRequest
   */
  dateIncurred?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentCostRequest
   */
  environmentName?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentCostRequest
   */
  serviceDescription?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentCostRequest
   */
  serviceID?: string;
}

/**
 * Check if a given object implements the ApitypesUpsertEnvironmentCostRequest interface.
 */
export function instanceOfApitypesUpsertEnvironmentCostRequest(
  value: object,
): value is ApitypesUpsertEnvironmentCostRequest {
  return true;
}

export function ApitypesUpsertEnvironmentCostRequestFromJSON(
  json: any,
): ApitypesUpsertEnvironmentCostRequest {
  return ApitypesUpsertEnvironmentCostRequestFromJSONTyped(json, false);
}

export function ApitypesUpsertEnvironmentCostRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApitypesUpsertEnvironmentCostRequest {
  if (json == null) {
    return json;
  }
  return {
    cloudHostID: json['cloudHostID'] == null ? undefined : json['cloudHostID'],
    cloudProvider:
      json['cloudProvider'] == null
        ? undefined
        : ApitypesCloudProviderFromJSON(json['cloudProvider']),
    cost: json['cost'] == null ? undefined : json['cost'],
    dateIncurred:
      json['dateIncurred'] == null ? undefined : json['dateIncurred'],
    environmentName:
      json['environmentName'] == null ? undefined : json['environmentName'],
    serviceDescription:
      json['serviceDescription'] == null
        ? undefined
        : json['serviceDescription'],
    serviceID: json['serviceID'] == null ? undefined : json['serviceID'],
  };
}

export function ApitypesUpsertEnvironmentCostRequestToJSON(
  json: any,
): ApitypesUpsertEnvironmentCostRequest {
  return ApitypesUpsertEnvironmentCostRequestToJSONTyped(json, false);
}

export function ApitypesUpsertEnvironmentCostRequestToJSONTyped(
  value?: ApitypesUpsertEnvironmentCostRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloudHostID: value['cloudHostID'],
    cloudProvider: ApitypesCloudProviderToJSON(value['cloudProvider']),
    cost: value['cost'],
    dateIncurred: value['dateIncurred'],
    environmentName: value['environmentName'],
    serviceDescription: value['serviceDescription'],
    serviceID: value['serviceID'],
  };
}
